import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router';

import { IUserData } from '../../../infrastructure/interfaces';
import UsersGroups from '../../../infrastructure/UsersRoles';

export interface IAgronomistRouteProps extends RouteProps {
  user?: IUserData;
  component: any;
  path: string;
}

@(connect((state: any) => ({ user: state.user.data })) as any)
export default class AgronomistRoute extends React.Component<IAgronomistRouteProps>{

  render() {
    const {
      user,
      component: Component,
      ...rest
    } = this.props;
    return (
      <Route {...rest} render={(props) => {
        return user
          ? user.role === UsersGroups.agronomist
            ? <Component />
            : <Redirect to="/Agronomist" />
          : <Redirect to="/Login" />;
      }} />);
  }
}



// WEBPACK FOOTER //
// ./src/components/App/components/AgronomistRouter.tsx